var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('movimiento-caja-dialog',{key:_vm.reload,attrs:{"tipo":"RETIRO"},on:{"process-dinero":_vm.processDinero,"close-dialog":function($event){return _vm.$emit('close-dialog')}}})}
var staticRenderFns = []

export { render, staticRenderFns }